import { useAction, useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { Button, CloseIcon } from '@blade/ui-kit'
import { ArrowLeftIcon } from '@root/shared/ui-kit'

import { walletsManagerModelAtom } from '../../atoms'

import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

type WalletDetailsSectionProps = {
  title?: React.ReactNode
  onBack?: () => void
  onClose: (() => void) | undefined
} & ClassNameProps &
  ChildrenProps

export const WalletDetailsSection = ({
  className,
  title,
  onBack,
  onClose,
  children,
}: WalletDetailsSectionProps) => {
  const [model] = useAtom(walletsManagerModelAtom)
  const clearSelectedWallet = useAction(model.clearSelectedWallet)
  const [, setScreen] = useAtom(model.walletDetailsScreen)

  return (
    <Root className={className}>
      <Header>
        {onBack ? (
          <Button
            variant="ghost"
            size="xxs"
            iconLeft={<ArrowLeftIcon />}
            onClick={onBack}
          />
        ) : (
          <Placeholder />
        )}
        <Title>{title}</Title>
        {onClose ? (
          <Button
            variant="ghost"
            size="xxs"
            iconLeft={<CloseIcon />}
            onClick={() => {
              clearSelectedWallet()
              setScreen('transactions')
            }}
          />
        ) : (
          <Placeholder />
        )}
      </Header>
      <Content>{children}</Content>
    </Root>
  )
}

const Placeholder = styled.div`
  height: 24px;
  width: 24px;
`

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  min-height: 0;
  height: 100%;
`

const Header = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 4px;
  padding-inline: 8px;
  padding-block: 8px;
`

const Title = styled.div`
  color: var(--text-11);
  text-align: center;

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

const Content = styled.div`
  min-height: 0;
`
WalletDetailsSection.Content = Content
WalletDetailsSection.Header = Header
WalletDetailsSection.Title = Title
